import React from "react";
import classes from "./bullkSparesListPage.module.css";
import { BulkSparesFilterPage } from "../bulkSparesFilter/BulkSparesFilterPage";
import { BulkSparesTablePage } from "../bulkSparesTable/BulkSparesTablePage";

export const BulkSparesListPage = () => {
  return (
    <div className={classes.box}>
      <BulkSparesFilterPage />
      <BulkSparesTablePage />
    </div>
  );
};
